var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHboMax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6020 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M713.3,995.6H447.2V616.1H274.9V995.6H2.3V16.4H274.9V381.7H447.2V16.4H713.3V995.6Zm1220.3,4.4c272.6,0,495.1-226.8,495.1-502.7C2428.7,217,2206.2,0,1933.6,0c-275.9,0-415.5,200.7-449.3,282.4,0-121-121.1-266.1-261.7-266.1H767.9V995.6H1191c172.3,0,293.3-147.2,293.3-275.9,38.2,79.6,173.4,280.3,449.3,280.3ZM1157.2,602c39.2,0,70.9,38.2,70.9,81.8,0,45.8-31.6,84-70.9,84H1022V602Zm0-367.5c39.2,0,70.9,38.2,70.9,81.8s-31.6,81.8-70.9,81.8H1022V234.5ZM1336,497.3c31.6-2.2,82.9-38.2,102.5-60-7.6,26.2-7.6,109.1,0,135.2-21.8-31.6-70.9-69.8-102.5-75.2Zm349,0c0-137.9,112.1-249.5,250.2-248.6a248.05,248.05,0,0,1,247,252.3c-2,136.7-112.5,246-248.6,246C1796.2,747,1685,635.8,1685,497.3Zm248.6,196.3c105.8,0,195.2-87.2,195.2-196.3s-89.4-195.2-195.2-195.2c-109.1,0-196.3,86.2-196.3,195.2s87.2,196.3,196.3,196.3Z",
    style: {
      fill: "#d6e0eb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3851,363C3845.5,125.7,3678,.1,3472.1.1c-113.1,0-214.6,37.9-284,111.4C3118.7,37.9,3017.2,0,2904.2,0c-206,0-373.6,125.8-378.9,363.4a8.08,8.08,0,0,0-.1,1.6V906a90,90,0,0,0,90,90h85a15,15,0,0,0,15-15V365h.1c3.6-117,86.8-179,188.9-179s185.3,62,188.9,179h.1V906a90,90,0,0,0,90,90h85a15,15,0,0,0,15-15V365h.1c3.6-117,86.8-179,188.9-179s185.3,62,188.9,179h.1V906a90,90,0,0,0,90,90h85a15,15,0,0,0,15-15V365A12.31,12.31,0,0,0,3851,363Z",
    style: {
      fill: "#d6e0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5765,16H5620.8a119.94,119.94,0,0,0-99.5,52.9L5361.9,305.3a52.41,52.41,0,0,1-87,0L5115.5,68.9A119.94,119.94,0,0,0,5016,16H4871.8a11.21,11.21,0,0,0-9.3,17.5l284.7,422.1a90.13,90.13,0,0,1,0,100.7L4862.5,978.4a11.22,11.22,0,0,0,9.3,17.5H5016a119.94,119.94,0,0,0,99.5-52.9l159.4-236.4a52.41,52.41,0,0,1,87,0L5521.3,943a119.94,119.94,0,0,0,99.5,52.9H5765a11.21,11.21,0,0,0,9.3-17.5L5489.6,556.3a90.13,90.13,0,0,1,0-100.7L5774.3,33.5A11.21,11.21,0,0,0,5765,16Z",
    style: {
      fill: "#d6e0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4796.2,16h-85a90,90,0,0,0-88,71c-75.8-57.5-170.4-87-273-87-248.9,0-450.7,173.2-450.7,500s201.8,500,450.7,500c101.9,0,195.9-29,271.4-85.8a90.1,90.1,0,0,0,89.6,81.8h85a15,15,0,0,0,15-15V31A15,15,0,0,0,4796.2,16Zm-446,797.9c-148.6,0-269.1-108.7-269.1-313.9s120.5-313.9,269.1-313.9S4619.3,294.8,4619.3,500,4498.8,813.9,4350.2,813.9Z",
    style: {
      fill: "#d6e0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5895.9,34.85h-28.3v85.2h-20.7V34.85h-28.2V15.05h77.2Z",
    style: {
      fill: "#d6e0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6017.7,120.05h-20.6V52l-29.5,48.7h-2.4l-29.5-48.6V120H5915V15h21.3l30.1,49.6,30-49.6h21.3v105.1Z",
    style: {
      fill: "#d6e0eb"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHboMax);
export default __webpack_public_path__ + "static/media/hbo-max.3f5b5fccd68811672ab05eb95dce13a9.svg";
export { ForwardRef as ReactComponent };